export default __webpack_public_path__ + "static/media/couriers.b914bc25.mp4";